export class ErrorConstants {
    public static readonly UnauthorizedErrorMessage: string = "Unauthorized";
    public static readonly FailedToFetchMessage: string = "Failed to fetch";
    public static readonly BadReponseMessage: string = "Bad reponse";
}

export class AAPErrorConstants {
    public static readonly InvalidTokenError: string = "InvalidToken";
}
